import React, { useState, useEffect } from "react"

import { Row, Col, Form } from "react-bootstrap"
import { observer } from "mobx-react"

import { BottomsheetDropdown, ChangeProductSection } from "components"
import DeathCoverGraphSlider from "../../death-cover-graph-slider/DeathCoverGraphSlider";
import AdditionalRiderBenifitsCard from "components/ui/additional-rider-benifits-card/AdditionalRiderBenifitsCard"
import fetchIncomeLabelBasedOnNeed from "utils/fetchIncomeLabelBasedOnNeed"
import DeathBenefitAmount from "utils/optimization/deathBenefitAmount";
import ComapreQuotesTable from "components/ui/compare-quotes-table/ComapreQuotesTable";
import { NUMBER_REGEX } from "constants/Constants";
import IsExistingCustomerModalForFDP from "../flexi-dream-plan/component/IsExistingCustomerModalForFDP";

const AssuredIncomeStar = ({ form, data }) => {
  const [showOverlay, setShowOverlay] = useState(false)
  let productData = data?.data?.BI.find((item) => item.risk === data?.data?.risk);
  let tabs = data.data.BI
  let updatedValues
  tabs.length > 0 &&
    tabs.map((tab) => {
      if (tab.risk === data.selectedTab) {
        updatedValues = tab.updatedValues ? tab.updatedValues : null
      }
    })

  let coverLabelBaseOnNeed = fetchIncomeLabelBasedOnNeed(data?.cardKey)


  const handleFunction = (value) => {
    form.$("is-existing-customer")?.extra?.toggleIsExistingCustomerModal(form, false)
    if (value) {
      form.$("is-existing-customer")?.set("value", { label: 'Yes', id: 1 })
    }
  }

  useEffect(() => {
    setShowOverlay(productData.fieldChanged)
  }, [productData.fieldChanged])

  const onHideOverlay = () => {
    setShowOverlay(false)
  }

  return (
    <div className="save-my-children">
      <Row className="align-items-center mt-4">
        <Col md={12} className="mt-3 mt-md-0">
          <ChangeProductSection
            productName={
              productData.product_name
            }
            cardName={coverLabelBaseOnNeed}
            changeProductList={data?.data?.changeProductList}
            productData={data}
            form={form}
          />
        </Col>

        {/* {form.$("payment-frequency").extra.isVisible &&
          <Col md={6} className="mb-4 mb-md-0">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("payment-frequency").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("payment-frequency").label}
              menuList={form.$("payment-frequency").extra.optionList}
              value={form.$("payment-frequency").value}
              onSelect={form.$("payment-frequency").onChange}
            />
          </Col>
        } */}
      </Row>

      <Row>
        <Col md={12}>
          <ComapreQuotesTable
            form={form}
            ptList={form.$("PT").extra.optionList}
            pptList={form.$("PPT").extra.optionList}
            ptValueId={form?.$("PT")?.value}
            ptName={"PT"}
            pptName={"PPT"}
            productData={data}
            cardKey={data.cardKey}
          />
        </Col>
      </Row>
      <DeathCoverGraphSlider
        productTitle="Active Income"
        openChangeReasonModal={false}
        onIncomeChange={() => { }}
        onPremiumChange={form.$("premium").onChange}
        productID={productData.product_id}
        productData={data?.data}
        income_value=""
        premium_value={form.$("premium").value}
        showOverlay={showOverlay}
        hideOverLay={onHideOverlay}
        onClick={() =>
          form
            .$("premium")
            .extra.calculatePremiun(form, productData.product_id, data)
        }
        data=""
        cardKey={data.cardKey}
        isIncomeFieldDisable={form.$("premium").disabled}
        premiumFreq={form.$("payment-frequency").value.label}
        formRef={form}
      />

      <Row className='mt-3 ml-0'>
        <p className='graph-label mb-2 font-size-12 font-size-md-14 font-weight-bold'>{"Sum Assured on Death (at inception of the policy):"}</p>
        <p className='graph-label pl-1 font-size-12 font-size-md-14 font-weight-bold'>{DeathBenefitAmount(productData)}</p>
      </Row>
      <Row className="mt-2 mt-md-4">
        <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("new-premium-offset-option").label}
          </div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey="label"
            bottomsheetTitle={form.$("new-premium-offset-option").label}
            menuList={form.$("new-premium-offset-option").extra.optionList}
            value={form.$("new-premium-offset-option").value}
            onSelect={form.$("new-premium-offset-option").onChange}
            disabled={form.$("new-premium-offset-option").disabled}
          />
        </Col>
      </Row>

      <Row className="">

        {form.$("PT").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("PT").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("PT").label}
              menuList={form.$("PT").extra.optionList}
              value={form.$("PT").value}
              onSelect={form.$("PT").onChange}
              disabled={form.$("PT").disabled}
            />
          </Col>
        }
        {form.$("PPT").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("PPT").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("PPT").label}
              menuList={form.$("PPT").extra.optionList}
              value={form.$("PPT").value}
              onSelect={form.$("PPT").onChange}
              disabled={form.$("PPT").disabled}
            />
          </Col>
        }


        {form.$("payment-frequency").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("payment-frequency").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("payment-frequency").label}
              menuList={form.$("payment-frequency").extra.optionList}
              value={form.$("payment-frequency").value}
              onSelect={form.$("payment-frequency").onChange}
              disabled={form.$("payment-frequency").disabled}
            />
          </Col>
        }

        <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("is-ecs-mandate").label}
          </div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey="label"
            bottomsheetTitle={form.$("is-ecs-mandate").label}
            menuList={form.$("is-ecs-mandate").extra.optionList}
            value={form.$("is-ecs-mandate").value}
            onSelect={form.$("is-ecs-mandate").onChange}
            disabled={form.$("is-ecs-mandate").disabled}
          />
        </Col>

        <Col md={4} className="col-12 mb-3">
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("is-existing-customer").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("is-existing-customer").label}
            menuList={form.$("is-existing-customer").extra.optionList}
            value={form.$("is-existing-customer").value}
            onSelect={(value) => {
              form.$("is-existing-customer").onChange(value)
              if (Number(value.id) === 1) {
                form.$("is-existing-customer")?.extra?.toggleIsExistingCustomerModal(form, true)
                form.$("is-existing-customer").set("value", { label: 'No', id: 2 })
              }
            }}
            disabled={Number(form?.$("is-existing-customer")?.value?.id) === 1 ? true : false}
          />
        </Col>
        <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("is-income-benefit-advance").label}
          </div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey="label"
            bottomsheetTitle={form.$("is-income-benefit-advance").label}
            menuList={form.$("is-income-benefit-advance").extra.optionList}
            value={form.$("is-income-benefit-advance").value}
            onSelect={form.$("is-income-benefit-advance").onChange}
            disabled={form.$("is-income-benefit-advance").disabled}
          />
        </Col>


        {/* <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("income-benefit-pay-out-type").label}
          </div>
          <Form.Group className='mb-0 flex-grow-1'>
            <Form.Control
              // className='font-size-lg-12 font-size-14 font-weight-light text-description-text-color h-100 border-gray rounded-0'
              className="font-size-12 font-weight-light text-black mt-2 product-form-field"
              placeholder=''
              disabled={form.$("income-benefit-pay-out-type").disabled}
              value={form.$("income-benefit-pay-out-type").value}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || (NUMBER_REGEX.test(value))) {
                  form.$("income-benefit-pay-out-type").onChange(e);
                }
              }
              }
              style={form.$("income-benefit-pay-out-type").error ? { border: "1px solid red" } : null}
            />
            {form.$("income-benefit-pay-out-type").error != null ? <p className='font-size-11 font-weight-light text-danger'>{formController.$("total-survival-benefit").error}</p> : null}
          </Form.Group>
        </Col> */}

        <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("plan-option").label}
          </div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey="label"
            bottomsheetTitle={form.$("plan-option").label}
            menuList={form.$("plan-option").extra.optionList}
            value={form.$("plan-option").value}
            onSelect={form.$("plan-option").onChange}
            disabled={form.$("plan-option").disabled}
          />
        </Col>
        <Col md={4} className="col-12 mb-3">
          <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("death-benefit-option").label}
          </div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey="label"
            bottomsheetTitle={form.$("death-benefit-option").label}
            menuList={form.$("death-benefit-option").extra.optionList}
            value={form.$("death-benefit-option").value}
            onSelect={form.$("death-benefit-option").onChange}
          />
        </Col>

        {form.$("sum-assured-on-maturity").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("sum-assured-on-maturity").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("sum-assured-on-maturity").label}
              menuList={form.$("sum-assured-on-maturity").extra.optionList}
              value={form.$("sum-assured-on-maturity").value}
              onSelect={form.$("sum-assured-on-maturity").onChange}
              disabled={form.$("sum-assured-on-maturity").disabled}
            />
          </Col>
        }
        {form.$("income-benefit-pay-out-frequency").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("income-benefit-pay-out-frequency").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("income-benefit-pay-out-frequency").label}
              menuList={form.$("income-benefit-pay-out-frequency").extra.optionList}
              value={form.$("income-benefit-pay-out-frequency").value}
              onSelect={form.$("income-benefit-pay-out-frequency").onChange}
              disabled={form.$("income-benefit-pay-out-frequency").disabled}
            />
          </Col>
        }
        {form.$("advantage-benefit-percentage").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("advantage-benefit-percentage").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("advantage-benefit-percentage").label}
              menuList={form.$("advantage-benefit-percentage").extra.optionList}
              value={form.$("advantage-benefit-percentage").value}
              onSelect={form.$("advantage-benefit-percentage").onChange}
              disabled={form.$("advantage-benefit-percentage").disabled}
            />
          </Col>
        }
        {form.$("accrual-of-survival-benefit").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("accrual-of-survival-benefit").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("accrual-of-survival-benefit").label}
              menuList={form.$("accrual-of-survival-benefit").extra.optionList}
              value={form.$("accrual-of-survival-benefit").value}
              onSelect={form.$("accrual-of-survival-benefit").onChange}
              disabled={form.$("accrual-of-survival-benefit").disabled}
            />
          </Col>
        }

        {!form.$("accrual-of-survival-benefit").extra.hide &&
          <Col xs={12} md={4} className='mb-3'>
            <p className='mb-2 font-size-12 font-weight-light '>{form.$("accrual-of-survival-benefit").label}</p>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("accrual-of-survival-benefit").label}
              menuList={form.$("accrual-of-survival-benefit").extra.optionList}
              value={form.$("accrual-of-survival-benefit").value}
              onSelect={form.$("accrual-of-survival-benefit").onChange}
              disabled={form.$("accrual-of-survival-benefit").disabled}
            />
          </Col>
        }
        {!form.$("asb-start-age-(1st-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>

            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-start-age-(1st-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-start-age-(1st-opt-in)").label}
              menuList={form.$("asb-start-age-(1st-opt-in)").extra.optionList}
              value={form.$("asb-start-age-(1st-opt-in)").value}
              onSelect={form.$("asb-start-age-(1st-opt-in)").onChange}
              disabled={form.$("asb-start-age-(1st-opt-in)").disabled}
            />

          </Col>
        }

        {!form.$("asb-end-age-(1st-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>

            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-end-age-(1st-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-end-age-(1st-opt-in)").label}
              menuList={form.$("asb-end-age-(1st-opt-in)").extra.optionList}
              value={form.$("asb-end-age-(1st-opt-in)").value}
              onSelect={form.$("asb-end-age-(1st-opt-in)").onChange}
              disabled={form.$("asb-end-age-(1st-opt-in)").disabled}
            />

          </Col>
        }

        {!form.$("withdrawal-parcentage-1").extra.hide &&
          <Col md={4} className='col-12 mb-3'>

            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("withdrawal-parcentage-1").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("withdrawal-parcentage-1").label}
              menuList={form.$("withdrawal-parcentage-1").extra.optionList}
              value={form.$("withdrawal-parcentage-1").value}
              onSelect={form.$("withdrawal-parcentage-1").onChange}
              disabled={form.$("withdrawal-parcentage-1").disabled}
            />

          </Col>
        }
        {/* {form.$("income-option").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("income-option").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("income-option").label}
              menuList={form.$("income-option").extra.optionList}
              value={form.$("income-option").value}
              onSelect={form.$("income-option").onChange}
              disabled={form.$("income-option").disabled}
            />
          </Col>
        } */}

        {/* {form.$("income-duration").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("income-duration").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("income-duration").label}
              menuList={form.$("income-duration").extra.optionList}
              value={form.$("income-duration").value}
              onSelect={form.$("income-duration").onChange}
              disabled={form.$("income-duration").disabled}
            />
          </Col>
        } */}

        {/* {form.$("premium-offset-option").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("premium-offset-option").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("premium-offset-option").label}
              menuList={form.$("premium-offset-option").extra.optionList}
              value={form.$("premium-offset-option").value}
              onSelect={form.$("premium-offset-option").onChange}
              disabled={form.$("premium-offset-option").disabled}
            />
          </Col>
        }

        {form.$("premium-offset-option-income-start-year").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("premium-offset-option-income-start-year").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("premium-offset-option-income-start-year").label}
              menuList={form.$("premium-offset-option-income-start-year").extra.optionList}
              value={form.$("premium-offset-option-income-start-year").value}
              onSelect={form.$("premium-offset-option-income-start-year").onChange}
              disabled={form.$("premium-offset-option-income-start-year").disabled}
            />
          </Col>
        } */}

        {/* {form.$("increasing").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("increasing").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("increasing").label}
              menuList={form.$("increasing").extra.optionList}
              value={form.$("increasing").value}
              onSelect={form.$("increasing").onChange}
              disabled={form.$("increasing").disabled}
            />
          </Col>
        } */}
        {/* 
        {form.$("cashback").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("cashback").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("cashback").label}
              menuList={form.$("cashback").extra.optionList}
              value={form.$("cashback").value}
              onSelect={form.$("cashback").onChange}
              disabled={form.$("cashback").disabled}
            />
          </Col>
        }
        {form.$("cashback-percentage").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("cashback-percentage").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("cashback-percentage").label}
              menuList={form.$("cashback-percentage").extra.optionList}
              value={form.$("cashback-percentage").value}
              onSelect={form.$("cashback-percentage").onChange}
              disabled={form.$("cashback-percentage").disabled}
            />
          </Col>
        } */}

        {/* {form.$("cashback-percentage").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("cashback-percentage").label}
            </div>
            <Form.Group className='mb-0 flex-grow-1'>
              <Form.Control
                // className='font-size-lg-12 font-size-14 font-weight-light text-description-text-color h-100 border-gray rounded-0'
               className="font-size-12 font-weight-light text-black mt-2 product-form-field"
                placeholder=''
                disabled={form.$("cashback-percentage").disabled}
                value={form.$("cashback-percentage").value}
                onChange={(e)=>{
                  const value = e.target.value;
                  const regex = /^\d*\.?\d*$/;
                  if (value === "" || (regex.test(value) && Number(value) <= 40)) {
                    form.$("cashback-percentage").onChange(e);
                  }
                }
                }
                style={form.$("cashback-percentage").error ? { border: "1px solid red" } : null}
              />
              {form.$("cashback-percentage").error != null ? <p className='font-size-11 font-weight-light text-danger'>{formController.$("cashback-percentage").error}</p> : null}
            </Form.Group>
          </Col>
        } */}
        {/* {form.$("income-benefit-payout-start-year").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("income-benefit-payout-start-year").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("income-benefit-payout-start-year").label}
              menuList={form.$("income-benefit-payout-start-year").extra.optionList}
              value={form.$("income-benefit-payout-start-year").value}
              onSelect={form.$("income-benefit-payout-start-year").onChange}
              disabled={form.$("income-benefit-payout-start-year").disabled}
            />
          </Col>
        } */}
        {/* {form.$("timing-of-income-from-income-start-year").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("timing-of-income-from-income-start-year").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("timing-of-income-from-income-start-year").label}
              menuList={form.$("timing-of-income-from-income-start-year").extra.optionList}
              value={form.$("timing-of-income-from-income-start-year").value}
              onSelect={form.$("timing-of-income-from-income-start-year").onChange}
              disabled={form.$("timing-of-income-from-income-start-year").disabled}
            />
          </Col>
        } */}
        {/* {form.$("sum-assure-multiple").extra.isVisible &&
          <Col md={4} className="col-12 mb-3">
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("sum-assure-multiple").label}
            </div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("sum-assure-multiple").label}
              menuList={form.$("sum-assure-multiple").extra.optionList}
              value={form.$("sum-assure-multiple").value}
              onSelect={form.$("sum-assure-multiple").onChange}
              disabled={form.$("sum-assure-multiple").disabled}
            />
          </Col>
        } */}
      </Row>
      <Row className="mt-4">
        {/* {!form.$("family-income-benefit-option").extra.hide &&
            <Col md={6} className='col-12 my-4 '>
              <AdditionalCards
                data={data}
                form={form}
              />
            </Col>} */}
        <Col md={6} className="col-12 my-4 ">
          <AdditionalRiderBenifitsCard
            data={data}
            form={form}
            showCriticalIllness={true}
            showIncomeBenefit={false}
            showHospitalityCashBenefit={false}
            showWOP={true}
            showPWB={true}
          />
        </Col>
      </Row>
      {form.$("is-existing-customer").extra.showExistingCustomerModal &&
        <IsExistingCustomerModalForFDP
          formRef={form}
          productData={productData}
          show={form.$("is-existing-customer").extra.showExistingCustomerModal}
          onHide={handleFunction}
        />
      }
    </div>
  )
}

export default observer(AssuredIncomeStar)
